// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeResourcesRedblue = {
  redblueActivity: "RedBlue activity",
  redblueActivityCamp: "RedBlue activity camp",
  redblueActivityMember: "RedBlue activity member",
  redblueActivitySeat: "RedBlue activity seat",
  redblueActivityTask: "RedBlue activity task",
  redblueAuth: "RedBlue authentication",
  redblueDirectorActivityTasks: "RedBlue director tasks",
  redblueDirectorDispatchTarget: "RedBlue director dispatch target",
  redblueDirectorEventSubject: "RedBlue director event subject",
  redblueDirectorNoticeTarget: "RedBlue director notice target",
  redblueJudgeScoreRecord: "RedBlue score record",
  redblueMember: "RedBlue member",
  redblueParticipant: "RedBlue participant",
  redblueParticipantReport: "RedBlue participant report",
  redblueParticipantReportTemplate: "RedBlue participant report template",
  redblueScheme: "RedBlue scheme",
  redblueSchemeVersion: "RedBlue scheme version",
  redblueDirector: "RedBlue director",
  redblueDirectorActivityTask: "RedBlue director activity task",
  redblueDirectorTaskAssignment: "RedBlue director task assignment",
  redblueDirectorTaskCodes: "RedBlue director task codes",
  redblueEnvironment: "RedBlue environment",
  redblueIntelligence: "RedBlue intelligence",
  redblueJudge: "RedBlue judge",
  redblueJudgeFinalScore: "RedBlue final score",
  redblueObserver: "RedBlue observer",
  redblueParticipantActivityTask: "RedBlue participant activity task",
  redblueSchemeDesign: "RedBlue scheme design",
  redblueSchemeTopologyBinding: "RedBlue scheme topology binding",
  redblueSchemeTopologySync: "RedBlue scheme topology sync",
  redblueBusinessEvent: "RedBlue business event",
} as const;
